import React from 'react';
import { gsap, Expo } from 'gsap';
import PropTypes from 'prop-types';
import useLanguage from '../../../../hooks/useLanguage';

const AboutMainScreen = ({ mainData }) => {
  const langToggle = useLanguage;

  const [tl] = React.useState(gsap.timeline({ paused: false }));
  let descr = React.useRef(null);
  let lineOne = React.useRef(null);
  let lineTwo = React.useRef(null);
  let lineThree = React.useRef(null);

  React.useEffect(() => {
    tl.to(descr, 1.5, { y: 0, opacity: 1, ease: Expo.easeOut, delay: 3.5 })
      .to(lineOne, 1.5, { y: 14, opacity: 1, ease: Expo.easeOut, delay: -1.25 })
      .to(lineTwo, 1.5, { y: 14, opacity: 1, ease: Expo.easeOut, delay: -1.25 })
      .to(lineThree, 1.5, {
        y: 14,
        opacity: 1,
        ease: Expo.easeOut,
        delay: -1.25,
      });
  }, [tl]);

  return (
    <section id="top-section" className="about-main" data-scroll-section>
      <div className="about-main__center">
        <span
          className="about-main__center-description__overflow"
          data-scroll=""
          data-scroll-speed="1"
          data-scroll-delay="0.05"
        >
          <span
            className="about-main__center-description"
            ref={(e) => (descr = e)}
          >
            {langToggle(mainData.description_ua, mainData.description_ru)}
          </span>
        </span>

        <h1
          className="about-main__center-title"
          data-scroll=""
          data-scroll-speed="-1"
          data-scroll-delay="0.05"
        >
          <span
            className="about-main__center-title__overflow"
            data-scroll=""
            data-scroll-speed="2"
            data-scroll-position="top"
          >
            {' '}
            <span
              className="about-main__center-title__line"
              ref={(e) => (lineOne = e)}
            >
              {langToggle(mainData.title_01_ua, mainData.title_01_ru)}
            </span>
          </span>
          <span
            className="about-main__center-title__overflow"
            data-scroll=""
            data-scroll-speed="1.5"
            data-scroll-position="top"
          >
            {' '}
            <span
              className="about-main__center-title__line"
              ref={(e) => (lineTwo = e)}
            >
              {langToggle(mainData.title_02_ua, mainData.title_02_ru)}
            </span>
          </span>
          <span
            className="about-main__center-title__overflow"
            data-scroll=""
            data-scroll-speed="1"
            data-scroll-position="top"
            // data-scroll-delay="0.05"
          >
            {' '}
            <span
              className="about-main__center-title__line"
              ref={(e) => (lineThree = e)}
            >
              {langToggle(mainData.title_03_ua, mainData.title_03_ru)}
            </span>
          </span>
        </h1>
      </div>
    </section>
  );
};

AboutMainScreen.propTypes = {
  mainData: PropTypes.object,
};

export default AboutMainScreen;
